"use client";

import { useState, useEffect } from "react";
import { EEA_COUNTRIES, STORAGE_KEYS, type EEACountry } from "@/lib/constants";

interface EEADetectionState {
  isEEA: boolean | null;
  country: string | null;
  isLoading: boolean;
}

const GEO_API_URL = "https://get.geojs.io/v1/ip/country.json";

export function useEEADetection(): EEADetectionState {
  const [state, setState] = useState<EEADetectionState>({
    isEEA: null,
    country: null,
    isLoading: true,
  });

  useEffect(() => {
    const detectCountry = async () => {
      try {
        const cached = localStorage.getItem(STORAGE_KEYS.CONSENT_COUNTRY);
        if (cached) {
          const isEEA = EEA_COUNTRIES.includes(cached as EEACountry);
          setState({ isEEA, country: cached, isLoading: false });
          return;
        }
      } catch {
        // localStorage not available
      }

      try {
        const response = await fetch(GEO_API_URL, { cache: "no-store" });
        if (!response.ok) throw new Error("Geo API failed");

        const data = await response.json();
        const country = data.country || null;

        if (country) {
          try {
            localStorage.setItem(STORAGE_KEYS.CONSENT_COUNTRY, country);
          } catch {
            // localStorage not available
          }
        }

        const isEEA = country
          ? EEA_COUNTRIES.includes(country as EEACountry)
          : false;

        setState({ isEEA, country, isLoading: false });
      } catch {
        setState({ isEEA: false, country: null, isLoading: false });
      }
    };

    detectCountry();
  }, []);

  return state;
}
